<script>
import axios from "axios";
// https://www.amcharts.com/docs/v4/tutorials/category/force-directed/
// import dataSircap from "../../stores/data/sircap.json";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;
let chart = null;
let dataSircap = null;
export default {
  name: "sircap",
  components: {},
  data() {
    return {};
  },
  methods: {
    setChart() {
      var chart = am4core.create("chartdiv", am4plugins_forceDirected.ForceDirectedTree);
      var series = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())
      chart.data = dataSircap;
      series.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      series.dataFields.children = "children";
      series.dataFields.color = "color";
      series.dataFields.fixed = "fixed";
      series.dataFields.name = "name";
      series.dataFields.value = "value";
      series.fontSize = 14;
      series.links.template.strokeWidth = 1;
      series.maxLevels = 10;
      series.tooltip.background.pointerLength = 0;
      // series.tooltip.pointerOrientation = "up";
      series.tooltip.getFillFromObject = false;
      series.tooltip.getStrokeFromObject = false;
      series.tooltip.stroke = am4core.color("#000");
      series.tooltip.background.fill = am4core.color("#ffffff");
      series.tooltip.background.fillOpacity = 1;
      // series.tooltip.dy = 80;
      series.tooltip.label.fill = am4core.color("#333333");
      series.links.template.strokeWidth = 5;

      // Node
      let node = series.nodes.template;
      console.log("series.nodes.template", series.nodes.template);
      node.outerCircle.disabled = true;
      node.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      node.fillOpacity = 1;
      node.label.text = "{name}"
      node.propertyFields.x = "x";
      node.propertyFields.y = "y";
      console.log("node =>", node);
      node.tooltipPosition = "fixed";
      node.tooltipHTML = `{tooltipText}`;
      // node.tooltipX = am4core.percent(100);
      // node.tooltipY = 100;
      node.fontSize = 13.5;
      node.fontWeight = 500;
      node.togglable = false;
      node.clickable = true;
      node.adapter.add("tooltipHTML", function (html, target) {
        let res = null;
        let data = target.dataItem.dataContext;
        // console.log("tooltipHTML =>", html);
        if (typeof (data.tooltipText) != "undefined" && data.tooltipText != null) {
          res = `<p style="margin-bottom:5px;padding-bottom:5px;border-bottom:1px dotted #ccc;color:{color};font-weight:600;font-size:18px;text-align:center;">{name}</p>
            <p style="margin-bottom:10px;color:#333333;line-height:16px;font-size:15px;width:500px;height:auto;text-align:center;">
              {tooltipText}<small class='d-block m-0 mt-1' style="color:#333333;font-weight:600;">Haz clic para mayor información</small>
            </p>`;
        }
        return res;
      });
      node.label.adapter.add("fontSize", function (fontSize, target) {
        return target.dataItem && target.dataItem.level == 0 ? 24 : fontSize;
      });
      node.label.adapter.add("fontWeight", function (fontWeight, target) {
        return target.dataItem && target.dataItem.level == 0 ? "700" : "600";
      });
      node.adapter.add("tooltipY", function (tooltipY, target) {
        // console.log("tooltipY!", target.dataItem.level);
        return target.dataItem && target.dataItem.level > 1 ? 160 : tooltipY;
      });
      node.events.on("over", function (ev) {
        let dataItem = ev.target.dataItem;
        if (dataItem && dataItem.dataContext.link && dataItem.dataContext.link != null) {
          const cursorStyle = document.createElement('style');
          cursorStyle.innerHTML = '*{cursor: pointer!important;}';
          cursorStyle.id = 'cursor-style';
          document.head.appendChild(cursorStyle);
        }
      });
      node.events.on("out", function (ev) {
        document.getElementById('cursor-style').remove();
      });
      node.events.on("hit", function (ev) {
        let dataItem = ev.target.dataItem;
        if (dataItem && dataItem.dataContext.link && dataItem.dataContext.link != null) {
          window.open(dataItem.dataContext.link, "_blank");
        }
      });
    }
  },
  async mounted() {
    console.clear();
    if (chart != null) chart.dispose();
    await axios
      .get(process.env.BASE_URL + "geo/sircap.json")
      .then(response => {
        dataSircap = response.data;
      });
    console.log("dataSircap =>", dataSircap);
    this.setChart();
  }
};
</script>

<template>
  <v-container>
    <v-card class="sircap">
      <v-img height="120px" src="img/sircap-header.png" cover></v-img>
      <v-card-text class="pl-10 pr-10 pt-6">
        <div class="row pb-4 bbd">
          <div class="col-md-9 mb-0 pb-0">
            <h1 class="title">
              SIRCAP<br>
              <small>Sistema de Rendición de Cuentas del Acuerdo de Paz</small>
            </h1>
          </div>
          <div class="col-md-3 pb-0">
            <img src="img/sircap-funcion-publica.png" style="width:140px;float: right;" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="subtitle">¿Qué es SIRCAP?</h4>
            <p class="pt-3">Es el mecanismo de transparencia y control social, creado por Función Pública para facilitar
              la
              información y
              el diálogo con la ciudadanía sobre los avances de la implementación del Acuerdo de Paz que incluye los
              informes anuales de las entidades con compromisos frente al acuerdo, herramientas para el diálogo con las
              ciudadanías y disposiciones legales, directrices y orientaciones para la rendición de cuentas, en
              cumplimiento
              de los compromisos 2.2.5. Control y veeduría ciudadana; 6.1.5. Sistema Integrado de Información; medidas
              para
              la transparencia que corresponden al punto 2 de participación política; y punto 6 de Implementación,
              verificación y refrendación del Acuerdo de Paz.
            </p>
            <p>Para conocer el detalle y navegar en el SIRCAP, haga clic en el componente de su interés en el gráfico:
            </p>
          </div>
          <div class="col-md-12">
            <div id="chartdiv"></div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style lang="scss">
.sircap {
  .sircap-tooltip {
    background-color: white;
    max-width: 200px;
  }

  #chartdiv {
    width: 100%;
    height: 550px;
    max-width: 100%
  }

  .bbd {
    border-bottom: 1px dotted #ccc;
  }

  h1 {
    &.title {
      font-weight: 600;
      letter-spacing: -1px !important;
      font-size: 1.6rem !important;
      line-height: 1.6rem;
      // color: red;
      font-family: "Work Sans",
        Helvetica,
        Arial,
        sans-serif !important;
    }
  }

  h4 {
    &.subtitle {
      font-weight: 600;
      letter-spacing: -1px !important;
      font-size: 1.3rem !important;
      font-family: "Work Sans",
        Helvetica,
        Arial,
        sans-serif !important;
    }
  }

  p {
    font-weight: 500;
    font-size: 1.1rem;
    color: #333333;
    letter-spacing: -0.6px;
  }

  .amcharts-tooltip-div {
    white-space: pre-wrap !important;
    /* Ensure the text wraps and respects new lines */
    text-align: justify;
    /* Justify text */
  }
}
</style>